import { render } from "./TSMCorrectionPage.vue?vue&type=template&id=a34fa564"
import script from "./TSMCorrectionPage.vue?vue&type=script&lang=js"
export * from "./TSMCorrectionPage.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__